import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Collapse from "@material-ui/core/Collapse";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import * as Dati from "../../Dati";
import * as Glob from "../../Globale";
import { Trad } from "../../components/";
import useToggle from "../../hooks/Toggle";

interface IMainNavItemMobileProps {
    Data: Dati.IDatiMenu;
    ToggleMenu: () => void;
}

const useStyles = makeStyles(theme => ({
    nested: {
        paddingLeft: theme.spacing(4)
    }
}));

export const _MainNavItemMobile: React.FC<IMainNavItemMobileProps> = ({ Data, ToggleMenu }) => {
    const classes = useStyles();
    const { open, toggle } = useToggle();

    return (
        <>
            <ListItem button onClick={toggle}>
                <ListItemText primary={Trad.Trad(Data.Voce)} />
                {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </ListItem>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    {Data.Azioni &&
                        Data.Azioni.map(
                            (item, index) =>
                                Glob.AzioneAbilitata(Data.ID_Funzione, item.Abilitazione) && (
                                    <ListItem button component="a" href={item.URL} onClick={ToggleMenu} className={classes.nested} key={index}>
                                        <ListItemText primary={Trad.Trad(item.Azione)} />
                                    </ListItem>
                                )
                        )}
                </List>
            </Collapse>
        </>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/layout/MainNavItemMobile.tsx